import React from "react";
import styled from "@emotion/styled";
import { CircularProgress, Box, CssBaseline, Stack } from "@mui/material";

import icon from "../vendor/icon.svg";
import logo from "../vendor/logo-black.svg";
import { common, neutral } from "../design-system/tokens";

const Root = styled.div`
  justify-content: center;
  display: flex;
  align-items: center;
  min-height: 100vh;
  background: ${neutral[200]};
  background: linear-gradient(
    0deg,
    ${neutral[200]} 0%,
    ${common.white} 100%,
    ${common.white} 100%
  );
`;

function SplashScreen() {
  return (
    <Root>
      <CssBaseline />
      <Stack>
        <Box sx={{ mt: 10, width: "250px" }}>Loading...</Box>
      </Stack>
    </Root>
  );
}

export default SplashScreen;
